import React, { useRef, useState } from "react";
import "../styles/Gallery.css";
import Modal from "react-modal";

const images = ["img/excavator.png", "img/road.png", "img/truck.png"];

const Gallery = () => {
  const galleryRef = useRef(null);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [currentImage, setCurrentImage] = useState(null);

  const scrollLeft = () => {
    galleryRef.current.scrollBy({
      top: 0,
      left: -300,
      behavior: "smooth",
    });
  };

  const scrollRight = () => {
    galleryRef.current.scrollBy({
      top: 0,
      left: 300,
      behavior: "smooth",
    });
  };

  const openModal = (image) => {
    setCurrentImage(image);
    setModalIsOpen(true);
  };

  const closeModal = () => {
    setModalIsOpen(false);
    setCurrentImage(null);
  };

  return (
    <>
      <h2 className="main-title gallery-h2" style={{ textAlign: "center" }}>
        GALERIA
      </h2>
      <div className="container"></div>

      <div className="gallery-container">
        <button className="nav-button" onClick={scrollLeft}>
          ◀
        </button>
        <div className="gallery" ref={galleryRef}>
          {images.map((src, index) => (
            <img
              key={index}
              src={src}
              alt={`Image ${index + 1}`}
              className="gallery-item"
              onClick={() => openModal(src)}
            />
          ))}
        </div>
        <button className="nav-button" onClick={scrollRight}>
          ▶
        </button>
      </div>
      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        contentLabel="Zoomed Image"
        className="modal"
        overlayClassName="overlay"
      >
        <button className="close-button" onClick={closeModal}>
          ×
        </button>
        {currentImage && <img src={currentImage} alt="Zoomed" className="modal-image" />}
      </Modal>
    </>
  );
};

export default Gallery;
